export const NAVIGATION_WIDTH = 80;
